import {formatString} from '@optimaxdev/utils';

export const PDP_CL = {
    action: formatString('{{action}}'),
    category: formatString('PDP CL - {{version}}'),
    label: formatString('{{label}}'),
    name: 'PDP',
};

export const PDP_BONUS_OFFER = {
    action: 'Product Details',
    category: formatString('PDP - {{version}}'),
    label: formatString('{{label}}'),
    name: 'PDP',
};
